module.exports = __webpack_public_path__ + "img/coach.9efede47.svg";